import Promise from 'bluebird'
import axios from 'axios'
import moment from 'moment'
import store from '@/store/index'

const state = {
  emailList: [],
  emailLoading: false
}

const mutations = {
  setEmails(state, emails) {
    state.emailList = emails
  },
  setEmailLoading(state, emailLoading) {
    state.emailLoading = emailLoading
  }
}

const actions = {
  fetchEmails({ commit }) {
    function processResp(obj) {
      obj.receivedAtLocal = moment(obj.receivedAt)
        .utc()
        .local()
        .format('DD MMM YYYY hh:mm:ss a')
      return obj
    }

    commit('setEmailLoading', true)
    return new Promise(resolve => {
      axios.get('/api/core/email?folder=Inbox&newOnly=true').then(response => {
        if (response.data) {
          let emails = [...response.data._embedded.emailModels]
          emails = emails.map(email => processResp(email))
          commit('setEmails', emails)
          commit('setEmailLoading', false)
          resolve(emails)
        } else {
          commit('setEmailLoading', false)
        }
      })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
